// src/pages/usa/puertorico/Guanica.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";  
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";


import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Jayuya ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Lajas() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Guánica, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Guánica, Puerto Rico</h2>

            <p>
              Guánica is a hidden gem in the southwestern corner of Puerto Rico, offering a 
              peaceful escape from city life. This coastal town is known for its beautiful
               beaches, calm atmosphere, and unique wildlife. One of its most iconic natural 
               treasures is the Bosque Seco de Guánica, a rare dry forest filled with diverse 
               plant and animal species found nowhere else on the island. Whether you want to 
               relax by the water, explore the Dry Forest, or experience the local way of 
               life, Guánica provides the perfect backdrop for an unforgettable visit.

            </p>

            <h3>🚗 Getting There</h3>

            <p>
             <p>
To reach Guánica, you can drive from San Juan, which takes approximately 2.5 to 3 hours. The 
most common route is via PR‑52 South and PR‑2 West, offering the fastest and most direct 
connection to the southwest region. If you're coming from Ponce, the drive is much shorter—about 
45 minutes via PR‑2 West. Travelers arriving through BQN (Rafael Hernández Airport in Aguadilla) 
can reach Guánica in roughly 1 hour to 1 hour and 15 minutes, typically following PR‑2 East through
 Aguada and Rincón before continuing toward the southern coast. Public transportation options are 
 limited, so renting a car is highly recommended for convenience and flexibility.

</p>

            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Fuerte Caprón:</strong> This historic fort, built in the 18th century, offers a glimpse into Puerto Rico's colonial past.
                  It is located on a hill overlooking the Caribbean Sea, providing stunning views of the coastline. 
                  The fort's strategic position allowed it to defend against pirate attacks and invasions. Today, 
                  visitors can explore the ruins, learn about its history, and enjoy the panoramic vistas. The site 
                  is also a popular spot for photography, especially during sunset when the sky is painted with vibrant colors.

                  Special note for visitors: If you are planning to visit the ruins of Fort Capron, keep in mind that the area is 
                  within the boundaries of the Bosque Seco “Dry Forest,” and it truly lives up to its name. The environment can 
                  be extremely hot, dry, and exposed, especially during midday. Be sure to bring enough water, avoid 
                  going alone, and let someone know your location before exploring the area. I’ve personally seen hikers coming from
                   the opposite side of the forest exhausted, thirsty, and disoriented while looking for any sign of life. There 
                   is one main trail that leads directly to the fort, and it is the recommended route for visitors.

                                
                  And not to scare the readers, but to make the visit a little more interesting, there are a few local
                   legends connected to Fort Capron and the surrounding area that many people in Guánica still 
                   talk about. These stories add a bit of mystery and personality to the hilltop ruins:<br />

1. The Watchman of the Hill — Locals say that at night, especially on quiet, windless evenings, people have seen a silhouette standing on the ridge where the fort once guarded the bay. Some describe it as a lone figure keeping watch over the coastline, as if the fort were still active.<br />

2. The Echoes of the Cannons — During strong storms, residents claim you can hear deep, distant booms coming from the hill. They describe it as the echo of old cannon fire rolling through the valley, even though the fort hasn’t fired a shot in over a century.<br/>

3. The Hidden Tunnel Rumor — There’s a long‑standing rumor that Fort Capron once had a secret escape tunnel leading down toward the shoreline. No physical evidence has ever been found, but older families in Guánica say their grandparents talked about it as if it were real.<br/>

4. The Dry Forest Spirits — The Bosque Seco de Guánica has its own folklore. Some hikers say that at dusk, you can hear soft footsteps or whispers deeper in the Dry Forest, even when no one else is around. The forest is ancient, and many locals treat it with a quiet respect, almost like a living guardian of the region.



                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.961002866899904, -66.90290074420011"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Dry Forest:</strong> The Guánica Dry Forest covers approximately 9,878 acres (about 40 km²), making 
                  it the largest and best‑preserved dry forest in Puerto Rico and one of the most important 
                  dry forest ecosystems in the Caribbean. The forest is home to a variety of unique plant and animal species, including the 
                   endangered Puerto Rican nightjar, a nocturnal bird that is native to the area. Visitors can explore several
                    trails that wind through the forest, offering opportunities for hiking, birdwatching, and photography. The forest's 
                    unique ecosystem is characterized by cacti, thorny shrubs, and other drought-resistant plants, creating a 
                    landscape that is both beautiful and ecologically significant.
                    Special note for visitors: keep in mind that the area it truly lives up to its name. The environment can 
                  be extremely hot, dry, and exposed, especially during midday. Be sure to bring enough water, avoid 
                  going alone, and let someone know your location before exploring the area. 

                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.971609852969273, -66.86868844729523"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Dry Forest 
                  </a>
                  <br />
                  </div>
              </li>

              
            </ul>

            <h3>🥾 Other Hidden Gems</h3>

<ul>

  <li>
    <div className="place-block">
      <strong>Coastal Drive: </strong >
      The Drive along the coast of Guánica "road 333" offers breathtaking views of the Caribbean Sea, 
      with several scenic spots to stop and take photos. The road winds through small fishing villages, providing
       a glimpse into local life. Along the way, you can find secluded beaches and coves that are perfect for a
        quiet afternoon. The coastal drive is especially beautiful during sunset, when the sky is painted with
         vibrant colors reflecting off the water.
      <br />
      <a
        href="https://www.google.com/maps?q=17.972146151111346, -67.03237794746178"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Cayo Aurora / Gilligans Island: </strong >
      Spending a day on Cayo Aurora, also known as Gilligan's Island, is a must when visiting Guánica.
       This small island is accessible by boat and is famous for its crystal-clear waters, perfect 
       for swimming and snorkeling. The island's shallow waters are home to a variety of marine life,
        making it an excellent spot for underwater exploration. Visitors can relax on the sandy
         beaches, enjoy a picnic, or take a guided tour to learn about the local ecosystem.
          The island's name comes from the popular TV show "Gilligan's Island," and it has become a
           beloved destination for both locals and tourists seeking a tropical getaway.
      <a
        href="https://www.google.com/maps?q=17.94246211656129, -66.87166035112732"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  
</ul>


            <h3>🛏️ Places to Stay in Guánica</h3>

<p>
  Guánica offers a mix of small hotels, guesthouses, and nature‑focused stays. 
  Below are some of the best options, organized with Expedia listings first, 
  followed by Booking.com.
</p>

<ul>
  <li>
    <div className="place-block">
      <strong>Parador Guánica 1929:</strong>
      A historic waterfront parador with a peaceful atmosphere, a pool, and easy access 
      to the town and nearby nature areas. One of the most popular stays in Guánica.
      <em> (Listed on Expedia & Booking)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Copamarina Beach Resort & Spa:</strong>
      A well‑known beachfront resort offering pools, restaurants, ocean views, and direct 
      access to nature trails. Great for families, couples, and beach lovers.
      <em> (Listed on Expedia & Booking)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Mary Lee’s by the Sea:</strong>
      A unique and colorful guesthouse near the coast, known for its quiet setting and 
      spacious units. Perfect for travelers seeking a peaceful, nature‑focused stay.
      <em> (Listed on Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hotel Parador Oasis:</strong>
      A simple, budget‑friendly option located near the main road. Offers clean rooms and 
      easy access to Guánica’s attractions.
      <em> (Listed on Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Local Guesthouses & Rentals:</strong>
      Guánica also has several small guesthouses and private rentals managed by local 
      families. These offer quiet stays and a more authentic experience.
      <em> (Some units not listed on Expedia or Booking)</em>
    </div>
  </li>
</ul>



            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I filmed in Jayuya. Be sure to set the quality to
              1080p or higher. Hope you enjoy them!
            </p>

            <p>
              <a
                href="https://youtu.be/neVJE5Kpzi8?si=VdKeq6RoAyip-S-i"
                target="_blank"
                rel="noopener noreferrer"
              >
                La Parguera
              </a>
            </p>

          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/Zeju5wOtEGk?si=UfQe11d3vsQVj9Ao"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/guanica/capron1.jpg"
                alt="Fort Capron"
              />
            </a>

            <img
              src="/images/usa/puertorico/guanica/capron.jpg"
              alt="Fort Capron"
            />
            <img
              src="/images/usa/puertorico/guanica/capron2.jpg"
              alt="Fort Capron"
            />
            <img
              src="/images/usa/puertorico/guanica/capron3.jpg"
              alt="Fort Capron"
            />
            <img
              src="/images/usa/puertorico/guanica/capron4.jpg"
              alt="Fort Capron"
            />
            <img
              src="/images/usa/puertorico/guanica/beach.jpg"
              alt="Beach"
            />
            <img
              src="/images/usa/puertorico/guanica/ruins.jpg"
              alt="Ruins"
            />
            <img
              src="/images/usa/puertorico/guanica/ruin2.jpg"
              alt="Ruins"
            />
            <img
              src="/images/usa/puertorico/guanica/ruin3.jpg"
              alt="Ruins"
            />
            <img
              src="/images/usa/puertorico/guanica/sunflowers.jpg"
              alt="Sunflower Farm"
            />
            <img
              src="/images/usa/puertorico/guanica/sunflower2.jpg"
              alt="Sunflower Farm"
            />




          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
